/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'goal-content.goal-about-content.description-edit-button': '編輯',
  'project-actions.project-content-about.edit-description-error-description': '發生錯誤，請在幾分鐘後再試一次。',
  'project-content.project-content-about.edit-description-error-title': '無法編輯專案描述',
  'project-content.project-content-about.the-measure-placeholder': '描述如何才算成功，以及您怎麼達成。',
  'project-content.project-content-about.the-measure-title': '如何知道是否成功',
  'project-content.project-content-about.the-what-placeholder': '描述這個專案以及其中的工作。',
  'project-content.project-content-about.the-what-title': '我們要做的事情是什麼？',
  'project-content.project-content-about.the-why-placeholder': '說明為什麼要進行這項工作，以及執行理由。',
  'project-content.project-content-about.the-why-title': '我們為什麼要做這件事？',
  'project-content.project-content-update-date.edited': '(已編輯)',
  'project-content.project-content-update-date.edited-tooltip': '編輯時間：{date}',
  'project-content.project-content-update-date.last-edited-by': '(上次編輯者：{name})',
  'project-content.project-content-updates.add-update': '新增更新',
  'project-content.project-content-updates.archived': '已封存',
  'project-content.project-content-updates.at-risk': '存在風險',
  'project-content.project-content-updates.cancelled': '已取消',
  'project-content.project-content-updates.completed': '已完成 🎉',
  'project-content.project-content-updates.date-changed': '已變更日期',
  'project-content.project-content-updates.edit-update': '編輯',
  "project-content.project-content-updates.for-date'": '{dueDate}',
  'project-content.project-content-updates.latest-update-title': '最近更新',
  'project-content.project-content-updates.missed-update-message': '沒有張貼任何更新',
  'project-content.project-content-updates.new-due-date': '新的截止日期',
  'project-content.project-content-updates.new-state': '新狀態',
  'project-content.project-content-updates.no-updates-description': '此專案尚未有更新。',
  'project-content.project-content-updates.off-track': '偏離正軌',
  'project-content.project-content-updates.old-due-date': '舊的截止日期',
  'project-content.project-content-updates.old-state': '舊狀態',
  'project-content.project-content-updates.on-track': '進度良好',
  'project-content.project-content-updates.paused': '已暫停',
  'project-content.project-content-updates.pending': '擱置中',
  'project-content.project-content-updates.previous-updates-title': '先前的更新',
  'project-content.project-content-updates.share-update': '分享',
  'project-content.project-content-updates.status-changed': '狀態已變更',
  'project-content.project-content-updates.write-update-button': '撰寫更新內容',
  'project-update-composer.modal-post-button-label': '張貼更新',
  'project-update-composer.modal-title': '張貼您的更新',
};
